import { useCallback, useState } from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { ChatIA } from '../components/ChatIA'
import { useFiltros } from '../state/FiltrosContext'

/** A página Pergunte à IA: a mesma conversa do botão flutuante, em tela cheia. */
export function ChatPage() {
  const { marcaId, marcas } = useFiltros()
  const [limpar, setLimpar] = useState<(() => void) | null>(null)
  const marca = marcas.find((m) => m.id === marcaId)?.nome
  const guardarLimpar = useCallback((f: (() => void) | null) => setLimpar(() => f), [])

  return (
    <Stack spacing={2} sx={{ maxWidth: 920, mx: 'auto', width: '100%' }}>
      <Stack direction="row" alignItems="flex-start" spacing={2}>
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="h5" sx={{ fontFamily: '"Outfit", sans-serif', fontWeight: 700, lineHeight: 1.2 }}>
            Pergunte à IA
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Perguntas sobre os números das marcas{marca ? ` (a marca do filtro é ${marca})` : ''}. A IA busca os dados pelos mesmos cálculos dos
            painéis e só responde com eles — cada número é conferido. Ela enxerga campanhas, conjuntos, anúncios e posicionamentos — ainda não o conteúdo dos criativos, públicos nem horários.
          </Typography>
        </Box>
        {limpar ? (
          <Button size="small" onClick={limpar} sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}>
            Nova conversa
          </Button>
        ) : null}
      </Stack>
      <ChatIA onNovaConversa={guardarLimpar} />
    </Stack>
  )
}
